import { useNavigate } from 'react-router-dom';
import ReadIcon from '../../../assets/icons/read.svg?react';
import UnreadIcon from '../../../assets/icons/unread.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';
import dayjs from 'dayjs';

const AlertItem = ({ alert, isSelected, onCheckboxChange, onDelete }) => {
  const navigate = useNavigate();
  const handleCheckboxChange = (e) => {
    e.stopPropagation(); // 이벤트 버블링 방지
    const checked = e.target.checked;
    onCheckboxChange(alert.DRiveNotificationSysId, checked);
  };

  const handleRowClick = (e) => {
    // 체크박스 클릭 시에는 상세 페이지로 이동하지 않음
    if (e.target.type === 'checkbox' || e.target.closest('input[type="checkbox"]')) {
      return;
    }
    navigate(`/system-alert-history/detail/${alert.DRiveNotificationSysId}`);
  };

  const convertType = (type) => {
    switch (type) {
      case 'INFO': return 'info';
      case 'WARNING': return 'warning';
      case 'ERROR': return 'error';
      case 'CRITICAL': return 'critical';
      case 'INTERACTION': return 'success';
      default: return 'unknown';
    }
  }


  return (
    <tr 
      key={alert.DRiveNotificationSysId}
      onClick={handleRowClick}
      style={{ cursor: 'pointer' }}
    >
      <td width="50px" onClick={(e) => e.stopPropagation()}>
        <input 
          type="checkbox" 
          checked={isSelected}
          onChange={handleCheckboxChange}
          onClick={(e) => {
            e.stopPropagation();
            // onChange만 처리하도록
          }}
        />
      </td>
      <td>{alert.IsRead ? <ReadIcon color='var(--gray-400)' /> : <UnreadIcon color='var(--primary-600)' />}</td>
      <td>
        <span className={`status-badge ${convertType(alert.Type)}`}>{alert.Type}</span>
      </td>
      <td>{alert.Title}</td>
      <td>{alert.IssuedDate ? dayjs(alert.IssuedDate).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
    </tr> 
  )
}

export default AlertItem